<template>
    <div class="modal-window uts025">
        <header class="modal-header">
            <div class="tit">{{modalInfo.title}}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="input-box">
                <input type="text" required :placeholder="modalInfo.name == 'registFolder'? $i18nUtil.trans('UB006.001'):$i18nUtil.trans('UB006.002')" v-model="folderName"  @input="displayBytes(maxBytes, folderName, $event)">
                <button type="button" class="input-txt-del" @click="folderName='', errorFolderName=true, error = false, checkBytes=0">입력 삭제</button>
                <div class="error" v-if="error ">{{ $i18nUtil.trans("message.CrudFolderModal.001","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
                <div class="error" v-if="errorFolderName " >{{ $i18nUtil.trans("UB006") }}</div>
            </div>
        </div>

        <footer class="modal-footer" v-if="modalInfo.name == 'registFolder'">
            <button type="button" class="btn_ty1" @click="callModalsContainer">{{ $i18nUtil.trans("button.CrudFolderModal.save","등록") }}</button> 
        </footer>
        <footer class="modal-footer" v-if="modalInfo.name == 'updateFolder'">
            <!-- <button type="button" class="btn_ty1" @click="$emit('close')">취소</button>  -->
            <button type="button" class="btn_ty1" @click="callModalsContainer">{{ $i18nUtil.trans("button.CrudFolderModal.save","등록") }}</button> 
        </footer>
    </div>
</template>
<script>

export default {
    props:{
        modalInfo: {
            type: Object,
            required: true,
        },
    },
    components: {
    },
    data() {
        return {  
            folderName: this.modalInfo.name == 'updateFolder' ? this.modalInfo.categoryName : '',

            error: false, 
            checkBytes: 0,
            maxBytes: 80,

            errorFolderName: false, //this.modalInfo.name == 'updateFolder' ? false: true,
        };
    },
    methods: { 
        callModalsContainer(){  
            if(this.error){
                return;
            }
            if(this.errorFolderName){
                return;
            }
            if(this.folderName == "" || this.folderName.length == 0){
                this.errorFolderName = true;
                return;
            }

            if(this.modalInfo.name == "registFolder"){ 
                let param ={
                    folderName : this.folderName,
                    groupId : this.modalInfo.groupId,
                    parentCategoryMid : this.modalInfo.parentCategoryMid,
                    regUserId : this.modalInfo.regUserId,
                    projectId : this.modalInfo.projectId
                } 
                this.$emit("registFolder", param);
                this.$emit('close');
            }else if(this.modalInfo.name == "updateFolder"){ 
                let param ={
                    selectedFolder : this.modalInfo.selectedFolder,
                    folderName : this.folderName,
                    parentCategoryMid : this.modalInfo.parentCategoryMid
                } 
                this.$emit("updateFolder", param);
                this.$emit("close");
                
            }
        },
        /* byte 체크 */
        displayBytes(byteLength, addCategoryName, _event) {
            let obj = this;
            addCategoryName = _event.target.value;
            obj.addCategoryName = addCategoryName;
            let checkBytes = obj.getByteLength(obj.addCategoryName);
            obj.checkBytes = checkBytes;
            obj.error = false;
            if(checkBytes > byteLength) {
              obj.error = true;
            }
            if(checkBytes > 0) {
              obj.errorFolderName = false;
            }else{
              obj.error = false;
              obj.errorFolderName = true;   
            }
        },
        getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
        },
        cutByteLength(s, len) {
            if (s == null || s.length == 0) {
                return 0;
            }
            var size = 0;
            var rIndex = s.length;
            for ( var i = 0; i < s.length; i++) {
                size += this.charByteSize(s.charAt(i));
                if( size == len ) {
                    rIndex = i + 1;
                    break;
                } else if( size > len ) {
                    rIndex = i;
                    break;
                }
            }
            return s.substring(0, rIndex);
        },
        charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        }, 
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/modal/CrudFolderModal.vue